import React, { useEffect, useRef, useContext, useState } from 'react';
import ReactEChartsCore from '../EChart';
import * as echarts from 'echarts/core';
import { getDates } from '../../../helpers/utils';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { useAppContext } from '../../../providers/AppProvider';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import { GaugeChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { ThemeVariant } from '../../../config';
import { tooltipFormatterList } from '../../../helpers/echart-utils';
import { Card } from 'react-bootstrap';
import { MachineDataContext } from '../../../providers/MachineDataContext';
import { color } from 'echarts';

dayjs.extend(isBetween);

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  GaugeChart,
  CanvasRenderer,
  LegendComponent
]);

const MachineSpeedGauge = ({ name, speed }) => {
  const chartRef = useRef(null);

  const option = {
    title: {
      text: name
    },
    series: [
      {
        type: 'gauge',
        max: 100,
        progress: {
          show: true,
          width: 10
        },
        axisLine: {
          lineStyle: {
            width: 2
          }
        },
        axisTick: {
          show: false
        },
        splitLine: {
          length: 6,
          lineStyle: {
            width: 2,
            color: '#999'
          }
        },
        axisLabel: {
          distance: 5,
          color: '#999',
          fontSize: 15
        },
        anchor: {
          show: true,
          showAbove: true,
          size: 12,
          itemStyle: {
            borderWidth: 10
          }
        },
        title: {
          show: false
        },
        detail: {
          valueAnimation: true,
          fontSize: 24,
          offsetCenter: [0, '110%'],
          color: '#999'
        },
        data: [
          {
            value: speed
          }
        ]
      }
    ]
  };

  // const machineData = useContext(MachineDataContext);

  // useEffect(() => {
  //   if (machineData && machineData.liveSpeed) {
  //     const actualSpeed = Number(machineData.liveSpeed.toFixed(2));
  //     const chart = chartRef.current.getEchartsInstance();
  //     chart.setOption({
  //       series: [
  //         {
  //           data: [{ value: actualSpeed }]
  //         }
  //       ]
  //     });
  //   }
  // }, [machineData]);

  return (
    <Card className="h-100">
      <Card.Body className="d-flex justify-content-center">
        <ReactEChartsCore
          // ref={chartRef}
          echarts={echarts}
          option={option}
          style={{ height: '316px', width: '120%' }}
        />
      </Card.Body>
    </Card>
  );
};

export default MachineSpeedGauge;
